import React from "react";
import { useTranslation } from "react-i18next";

import {
  Tabs
} from '@lockerpm/design';

const PlanTabs = (props) => {
  const { t } = useTranslation()
  const {
    className = '',
    selectedMenu = '',
    onChange = () => {}
  } = props;
  return (
    <div className={className}>
      <Tabs
        activeKey={selectedMenu}
        items={[
          {
            key: 'choose_plan',
            label: t('manage_plans.choose_plan')
          },
          {
            key: 'payment',
            label: t('manage_plans.payment')
          },
        ]}
        onChange={onChange}
      />
    </div>
  );
}

export default PlanTabs;